import emailCompose from './emailCompose.html';
import emailContent from './emailContent.html';
import emailList from './emailList.html';

const emailConfig = ($stateProvider) => {
    $stateProvider
        .state('email', {
            url: '/email',
            template: emailList,
            controller: 'EmailController',
            controllerAs: 'email'
        })
        .state('emailCompose', {
            url: '/email/add',
            template: emailCompose,
            params: { contactExtension: null, campaignId: null, taskId: null},
            controller: 'EmailController',
            controllerAs: 'email'
        })
        .state('emailContent', {
            url: '/email/list/:emailId',
            template: emailContent,
            controller: 'EmailController',
            controllerAs: 'email'
        });

};

export default emailConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/email/email.config.js
 **/